<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">Custom Fields</div>
        <div class="section-subTitle my-2">Manage All your Custom Fields here.</div>
      </div>
      <div>
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <!-- v-if="cinema_manager_add_edit_disabled != 3" -->
        <!-- <b-button variant="default" :to="{name: 'Add Custom Fields'}" class="btn-blue">{{ $t('add') }}</b-button> -->
      </div>
    </div>

    <!-- <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
            >{{list.name}}</b-dropdown-item>
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active':''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active':''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>-->

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container">
      <div class="desg-list-header">
        <div>Modules</div>

        <div class="pr-5">{{ 'Add/Edit' }}</div>
      </div>
      <ul class="desg-list">
        <li v-for="(module, modulesKey) in modules" :key="modulesKey">
          <div>{{module.name}}</div>

          <div class="d-flex align-items-center">
              <button class="btn-blue" @click.prevent.stop="toAdd(module)">Add/Edit</button>
            <!-- <label class="ios-switch">
              <input
                
                value="Y"
                disabled
                type="checkbox"
                class="ios-checkbox"
              />
              <span class="switch-slider"></span>
            </label> -->
            <!-- <b-dropdown right variant="edit" class="ml-4">
              <b-dropdown-item
                :to="{ name: 'Add Custom Fields',params:{module: module.id} }"
              >
                <span class="edit-pen mr-1"></span>
                Add/Edit
              </b-dropdown-item> -->
              <!-- <b-dropdown-item
                :to="{ name: 'View Segment',params:{segment_id:segment.segment_id} }"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t('view') }}
              </b-dropdown-item> -->
            <!-- </b-dropdown> -->
          </div>
        </li>
      </ul>
      <!-- <table>
        <tbody>
          <tr>
            <td colspan="2">
              <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div>
            </td>
          </tr>
        </tbody>
      </table>-->
    </div>
    <br />
    <!-- <b-pagination
      v-model="currentPage"
      total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>-->
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      modules :[{id:1 ,name:'Movies'},
      {id: 2, name:'Cinemas'}]
    };
  },
  mounted() {
    // this.getSegments();
  },
  methods: {
      toAdd(module){
          this.$router.push({ name: 'Add Custom Fields',params:{module: module.id} })
      }
    // getSegments() {
    //   MarketingAutomation.GetSegments()
    //     .then(response => {
    //       const { data } = response;
    //       if (data && data.status) {
    //         this.mapped_customer_segments = data.Records;
    //         console.log(
    //           "this.mapped_customer_segments :",
    //           this.mapped_customer_segments
    //         );
    //       } else {
    //         this.$toasted.show(data.message);
    //       }
    //     })
    //     .catch(error => {
    //       this.$toasted.show(error);
    //     });
    // }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CustomFieldsComponents/CustomFields.vue